import Api from '../../../common/api/index';

export function addItemsToRental(warehouseRentalId, data) {
  return Api().post( `/warehouses/${warehouseRentalId}/add_items_to_rental`, data);
}